module.exports = __webpack_public_path__ + "img/ic-contact-line.4af6cfd0.png";